import { render, staticRenderFns } from "./dianpu_details.vue?vue&type=template&id=19dccb2f&scoped=true&"
import script from "./dianpu_details.vue?vue&type=script&lang=js&"
export * from "./dianpu_details.vue?vue&type=script&lang=js&"
import style0 from "./dianpu_details.vue?vue&type=style&index=0&id=19dccb2f&prod&lang=less&"
import style1 from "./dianpu_details.vue?vue&type=style&index=1&id=19dccb2f&prod&lang=css&"
import style2 from "./dianpu_details.vue?vue&type=style&index=2&id=19dccb2f&prod&lang=less&scoped=true&"
import style3 from "./dianpu_details.vue?vue&type=style&index=3&id=19dccb2f&prod&lang=less&"
import style4 from "./dianpu_details.vue?vue&type=style&index=4&id=19dccb2f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dccb2f",
  null
  
)

export default component.exports